import { useEffect, useRef } from 'react'

import { useMenuContext } from 'context/menu-context'

export const useMenuItem = () => {
  const { addMenuItem } = useMenuContext()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current) {
      const label = ref.current.getAttribute('data-menu-label')

      if (label) {
        addMenuItem({ element: ref.current, label })
      }
    }
  }, [])

  return ref
}
